// src/context/CartContext.js
import React, { createContext, useContext, useReducer } from "react";

const CartContext = createContext();

const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD_ITEM": {
      const key = `${action.item.id}-${action.item.selectedSize}-${action.item.selectedColor}`;
      const existing = state.items.find(i => i.key === key);
      if (existing) {
        return { ...state, items: state.items.map(i => i.key === key ? { ...i, qty: i.qty + 1 } : i) };
      }
      return { ...state, items: [...state.items, { ...action.item, key, qty: 1 }] };
    }
    case "REMOVE_ITEM":
      return { ...state, items: state.items.filter(i => i.key !== action.key) };
    case "UPDATE_QTY":
      return { ...state, items: state.items.map(i => i.key === action.key ? { ...i, qty: action.qty } : i) };
    case "MOVE_TO_WISHLIST":
      return {
        ...state,
        items: state.items.filter(i => i.key !== action.key),
        wishlist: [...state.wishlist.filter(w => w.key !== action.key), { ...state.items.find(i => i.key === action.key) }],
      };
    case "TOGGLE_WISHLIST": {
      const exists = state.wishlist.find(w => w.id === action.item.id);
      return {
        ...state,
        wishlist: exists ? state.wishlist.filter(w => w.id !== action.item.id) : [...state.wishlist, action.item],
      };
    }
    case "TOGGLE_SELECT":
      return { ...state, items: state.items.map(i => i.key === action.key ? { ...i, selected: !i.selected } : i) };
    case "SELECT_ALL":
      return { ...state, items: state.items.map(i => ({ ...i, selected: true })) };
    case "CLEAR_CART":
      return { ...state, items: [] };
    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, { items: [], wishlist: [] });

  const addItem = (item) => dispatch({ type: "ADD_ITEM", item });
  const removeItem = (key) => dispatch({ type: "REMOVE_ITEM", key });
  const updateQty = (key, qty) => dispatch({ type: "UPDATE_QTY", key, qty });
  const moveToWishlist = (key) => dispatch({ type: "MOVE_TO_WISHLIST", key });
  const toggleWishlist = (item) => dispatch({ type: "TOGGLE_WISHLIST", item });
  const toggleSelect = (key) => dispatch({ type: "TOGGLE_SELECT", key });
  const selectAll = () => dispatch({ type: "SELECT_ALL" });
  const clearCart = () => dispatch({ type: "CLEAR_CART" });

  const cartCount = state.items.reduce((s, i) => s + i.qty, 0);
  const selectedItems = state.items.filter(i => i.selected !== false);
  const cartTotal = selectedItems.reduce((s, i) => s + i.price * i.qty, 0);
  const cartMRP = selectedItems.reduce((s, i) => s + i.mrp * i.qty, 0);
  const memberSavings = Math.round(cartMRP * 0.09);

  return (
    <CartContext.Provider value={{
      items: state.items, wishlist: state.wishlist,
      addItem, removeItem, updateQty, moveToWishlist,
      toggleWishlist, toggleSelect, selectAll, clearCart,
      cartCount, cartTotal, cartMRP, memberSavings,
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
